export default "__VITE_ASSET__DaWuKr5r__"